import { Flex, Typography } from "antd";

const WebServerA: React.FC = () => {
    return (
        <Flex gap="middle" align="center" vertical>
            <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
                ホーム画面-Aへようこそ！
            </Typography.Text>
        </Flex>
    );
};

export default WebServerA;